<template lang='pug'>
//- 上傳血壓血糖的照片範例
div(:class='$style[`cc-popbox-blood-upload`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-popbox-blood-upload-title`]')
    span.font-bold 正確的
    span.font-bold.font-doctor-theme.no-wrap 血壓血糖
    span.font-bold 照片範例

  div(:class='$style[`cc-blood-upload-wrap`]')
    div(:class='$style[`cc-blood-upload-wrap-block`]')
      header.font-bold(:class='$style[`cc-blood-upload-wrap-block-title`]') 清楚拍攝顯示的數值
      div(:class='$style[`cc-blood-upload-wrap-block-info`]')
        span(style="padding-bottom: 15px;") 請上傳您測量設備的數值照片。拍攝時，請正對螢幕，確保畫面僅包含完整、清晰的數字，避免傾斜、裁切或拍入周圍雜物。

        figure
          img(:src='`${STATIC_URL}images/news/blood/step1.webp`' width='100%')
        figure
          img(:src='`${STATIC_URL}images/news/blood/step2.webp`' width='100%')

    div(:class='$style[`cc-content-blood-upload-controller`]')
      button.btn-extra.font-medium(
        aria-label='知道了'
        tabindex='0'
        :class='$style[`cc-blood-upload-controller-btn`]'
        @click='handleClosePopBox') 知道了

</template>

<script>
import { mapMutations } from 'vuex';
import IconCcoin from '../../icon/Ccoin';

export default {
  components: {
    IconCcoin,
  },

  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
    }),

    handleClosePopBox() {
      this.changePopShowTutorialStatus({
        active: false,
        include: '',
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     loginStatus: 'user/exportLoginStatus',
  //     loginProfile: 'user/exportUserProfile',
  //   }),
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popHowToUploadBlood.scss';
</style>
